module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('LessonsModule', {
    attrs: {
      "isLoading": _vm.isLoading,
      "data": _vm.lessons
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75a62eb4","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/remote-edu/views/lessons/Lessons.vue
// module id = afba3a5b10b2158236cf
// module chunks = 26